import { IdeationVoteEditorVMConfig } from 'components/editors/thread/text/ideationVote/ideationVote';
import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import IdeationManager from 'managers/ideation';
import { IWCCStorageManager } from 'managers/iStorage';
import TopicVotesManager from 'managers/topic/votes';
import { TopicThread } from 'models/topicThread';
import './ideationVoter.html';
import './ideationVoter.scss';

components.preload('ideation-vote-editor-standalone');

export interface CommentIdeationVoterVMConfig {
    comment: SubscribableOrNullableValue<TopicThread>
}

@injectable()
export default class CommentIdeationVoterVM {
    labels = labels;

    votesPickerContainer = ko.observable<HTMLElement>();

    comment: Subscribable<TopicThread | undefined>
    id: Subscribable<string | undefined>
    topicId: Subscribable<string | undefined>

    voteEditorConfig: IdeationVoteEditorVMConfig

    repliesShown: Subscribable<boolean>
    canVote: Subscribable<boolean>
    isReady: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: CommentIdeationVoterVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager
    ) {
        this.comment = ko.flattenComputed(config.comment);
        this.id = this.comment.pluck(c => c.id);
        this.topicId = this.comment.pluck(c => c.topicId);

        const ideationManager = storage.get(IdeationManager, { topicId: this.topicId });
        const ideationReady = ideationManager.pluck(m => m.isReady, false);
        const isVotingStage = ideationManager.pluck(m => m.isVotingStage, false);

        const votesManager = storage.get(TopicVotesManager, { topicId: this.topicId });
        const loadingVotes = votesManager.pluck(m => m.loading, true);
        const votes = votesManager.pluck(m => m.votes, []);
        const vote = votes.find(v => v.threadId() === this.id());
        const voted = vote.isNotNull();

        this.voteEditorConfig = { parentThread: this.comment, votesPickerContainer: this.votesPickerContainer }

        this.repliesShown = ko.pureComputed(() => voted());
        this.canVote = ko.pureComputed(() => !voted());

        this.isReady = ko.pureComputed(() => {
            return ideationReady() &&
                !loadingVotes() &&
                isVotingStage();
        });

        ko.applyBindingsToNode(info.element, {
            'visible': this.isReady,

            'css': {
                'topic__comment__ideation-voter': true
            }
        }, this);
    }
}